import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Guard для проверки авторизации пользователя
 * Перенаправляет на /login если пользователь не авторизован
 */
export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    console.warn('User not authenticated, redirecting to login');
    router.navigate(['/login']);
    return false;
  }

  return true;
};
